import { isGlMapHideOperation } from '@festina/configuration-general-types/configuration'
import { STANDARD_BRANCH } from '@festina-life/api'
import { dateUtils } from '@festina-life/core'
import { Group } from '@visx/group'

import { useDraftContext } from '../../context/draftContext'
import { useMappingId } from '../../system/useMappingId'
import { useNavigationParams } from '../../system/useNavigationParams'
import { getGlMapOperationFromDate } from '../../uiModels/glMapOperations/helpers'
import type { IndexedGlMapOperationWithMetaData } from '../../uiModels/glMapOperations/types'
import { useIsPersonaEditor } from '../../uiModels/useIsPersonaEditor'
import { NO_DATE_SYMBOL } from '../../util/constants'
import { getHiddenTimeIntervals } from '../versionedTimeline/helpers'
import type { ChildProps } from '../versionedTimeline/VersionedArrowsGroup'
import { VersionedTimeline } from '../versionedTimeline/VersionedTimeline'
import { GlMapVersionsForDate } from './GlMapVersionsForDate'

export const GlMapVersionsLine = ({
  versions,
  lineStartDate,
  lineEndDate,
  lineLength,
}: ChildProps<IndexedGlMapOperationWithMetaData>) => {
  const mappingId = useMappingId()
  const { branch, layer } = useNavigationParams()
  const { onConfigureNewDraft } = useDraftContext()
  const isEditor = useIsPersonaEditor()

  const handleCreateDraft = (fromDate: Date) =>
    onConfigureNewDraft(
      {
        type: 'glMap',
        value: {
          mappingId,
          fromDate: dateUtils.dateAsServerStr(fromDate),
          isHideOperation: true,
        },
      },
      layer,
    )

  return (
    <Group>
      <VersionedTimeline
        lengthInPixels={lineLength}
        startDate={lineStartDate}
        endDate={lineEndDate}
        versions={versions}
        versionDate={(version) =>
          getGlMapOperationFromDate(version.internalOperation) ?? NO_DATE_SYMBOL
        }
        onCreateDraft={
          branch && branch !== STANDARD_BRANCH && isEditor
            ? handleCreateDraft
            : undefined
        }
        renderDateVersions={({ date, versions, dateToPixel }) => (
          <GlMapVersionsForDate
            key={date.toString()}
            versions={versions}
            dateToPixel={dateToPixel}
          />
        )}
        hiddenTimeIntervals={getHiddenTimeIntervals({
          items: versions,
          getFromDate: (version) =>
            getGlMapOperationFromDate(version.internalOperation),
          isHideItem: (version) =>
            isGlMapHideOperation(version.internalOperation),
          endDate: lineEndDate,
        })}
      />
    </Group>
  )
}
